const ConsumerErrorStatus = {
    GENERIC: '000',
    PLAYBACK_INTERRUPTED_CONNECTION_LOST: '001',
    PLAYBACK_SOURCE_STARTUP: '011',
    DRM: '012',
    PLAYBACK_SOURCE_MIDSTREAM: '013',
    BAD_REQUEST: '400',
    UNAUTHORIZED: '401',
    FORBIDDEN: '403',
    NOT_FOUND: '404',
};

export default ConsumerErrorStatus;
